<template>
  <button
    type="button"
    class="text-sm/5 flex flex-col bg-white hover:bg-gray-50 rounded-lg cursor-pointer px-4 py-3 w-full text-left"
  >
    <span class="font-medium">{{ title }}</span>
    <span class="text-gray-500">{{ subtitle }}</span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  subtitle: string
}>()
</script>
